<div edsGrid>
  <div edsRow>
    <div edsCol>
      <eds-section-header
        [title]="'products.price-highest-lowest-nav' | translate: fundId"
        [level]="6"
        [asOfLabel]="'products.as-at' | translate"
        [asOfDate]="navAsOfDate"
        [updateFrequency]="'products.updated-daily' | translate"
        caveatPlacement="Price:HighestLowestNAVPriceDistribution"
        edsSpacing="md"
      ></eds-section-header>
    </div>
  </div>

  <div edsRow>
    <div edsCol>
      <table
        class="table table--tertiary"
        #tableResponsive
        [style.display]="(isHandheld$ | async) ? 'none' : ''"
      >
        <thead class="table__thead">
          <tr class="table__tr">
            <th class="table__th">{{ "products.year" | translate }}</th>
            <th
              class="table__th"
              *ngFor="let highLowNavData of highLowNavTableData"
            >
              {{ highLowNavData.year }}
            </th>
          </tr>
        </thead>

        <tbody class="table__body">
          <tr class="table__tr">
            <td class="table__td">
              {{ "pds.HIGH_NAV_VALUE_YTD" | translate: fundId }}
            </td>
            <td
              class="table__td"
              *ngFor="let highLowNavData of highLowNavTableData"
            >
              <p class="spacing--none">
                {{ highLowNavData.highestNav }}
              </p>
              <p class="small">
                {{ "products.as-on" | translate: fundId }}
                {{ highLowNavData.highestNavDate }}
              </p>
            </td>
          </tr>
          <tr class="table__tr">
            <td class="table__td">
              {{ "pds.LOW_NAV_VALUE_YTD" | translate: fundId }}
            </td>
            <td
              class="table__td"
              *ngFor="let highLowNavData of highLowNavTableData"
            >
              <p class="spacing--none">
                {{ highLowNavData.lowestNav }}
              </p>
              <p class="small">
                {{ "products.as-on" | translate }}
                {{ highLowNavData.lowestNavDate }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <div edsRow *ngFor="let card of cards">
        <div edsCol *ngIf="isHandheld$ | async">
          <eds-panel
            edsSpacing="sm"
            [hasBorders]="true"
            [hasBorderRadius]="false"
            [hasPadding]="true"
          >
            <eds-info-item
              *ngFor="let item of card"
              [info]="item"
              edsSpacing="sm"
            >
            </eds-info-item>
          </eds-panel>
        </div>
      </div>
      <eds-proximal placement="DailyPricesProximalBottom"></eds-proximal>
    </div>
  </div>
</div>
